import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import * as fromUserReducer from './UserReducer';
import * as fromAuthReducer from './AuthReducer';
import * as fromOrderReducer from './OrderReducer';
import * as fromLanguagesReducer from './LanguagesReducer';
import * as fromViewManagementReducer from './ViewManagementReducer';
import * as fromFilesReducer from './FilesReducer';
import { createBrowserHistory } from 'history';

export type RootState = {
  router: any;
  userStore: fromUserReducer.State;
  authStore: fromAuthReducer.State;
  orderStore: fromOrderReducer.State;
  languagesStore: fromLanguagesReducer.State;
  filesStore: fromFilesReducer.State;
  viewManagementStore: fromViewManagementReducer.State;
};

export const history = createBrowserHistory();

const rootReducer = combineReducers<RootState>({
  router: connectRouter(history),
  userStore: fromUserReducer.userReducer,
  authStore: fromAuthReducer.authReducer,
  orderStore: fromOrderReducer.orderReducer,
  languagesStore: fromLanguagesReducer.languagesReducer,
  filesStore: fromFilesReducer.filesReducer,
  viewManagementStore: fromViewManagementReducer.viewManagementReducer,
} as any);

const appReducer = (state: RootState, action) => {
  if (action.type === 'LOG_OUT_SUCCESS') {
    // state.authStore = undefined;
    // state.viewManagementStore.isMenuExpanded = false;
    // state.router = {
    //   router: { ...state.router },
    // };
  }
  return rootReducer(state, action);
};

export default appReducer;
